import React from 'react'
import ModalComponent from './ModalComponent'

export default function DeleteModal(props) {
    return (
        <div>
            {props.showDeleteModal ?
                <ModalComponent>
                    <div class="modal-dialog">
                        <div class="modal-content py-4">
                            <div class="modal-body text-center">

                                <h6>  Do you want to delete this item?</h6>
                                <div className='d-flex justify-content-center pt-3'>
                                    <button type="button" class="btn btn-primary" onClick={() => props.onDeleteFunction()}>Submit</button>
                                    <button type="button" class="btn btn-danger" onClick={() => props.onCancelFunction()}>Cancel</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </ModalComponent> : ""}
        </div>
    )
}
